import styled from 'styled-components';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints';
import { ImageWrapper } from '@mlb/react-patterns/components/Image/image.style';
import { StyledBaseSkeleton } from '@mlb/react-patterns/components/Skeleton/skeleton.style';
import Team from '@mlb/react-patterns/components/Team/team';
import {
    DataWrapper,
    DesktopRecordWrapper,
    DesktopStandingsWrapper,
    OuterWrapper,
    NameWrapper
} from '@mlb/react-patterns/components/Team/team.style';

import GDBREAKPOINTS from '../themes/breakpoints';
import { MatchupStateWrapper } from '../PlayerDuel/PlayerDuel.style';

const { XS_MAX } = GDBREAKPOINTS;

export const TeamWrapper = styled.div`
    ${({ hideData, logoSize }) => hideData ? `width: ${logoSize}px;` : ''}
    img {
        margin-top: 0;
    }
    ${ImageWrapper} {
        /*
            TODO: There's a bug in patters where logoSize is added to the css,
            but Team only allows a number as that prop. Might be a breaking change
            in patterns to fix.
        */
        width: ${({ logoSize }) => `${logoSize}px`};
        height: ${({ logoSize }) => `${logoSize}px`};
    }
    ${OuterWrapper} {
        /* OuterWrapper has an unnamed div from patterns */
        > div:first-of-type {
            align-items: center;
        }
    }
    ${DataWrapper} {
        ${({ hideData }) => hideData ? 'display: none;' : ''}
        color: var(--gameday-primary-font-color);
        ${NameWrapper} {
            font-size: 12px;
            line-height: 12px;
            font-weight: 700;
        }

        ${DesktopRecordWrapper} {
            font-size: 12px;
            line-height: 12px;
            font-weight: 500;
            color: var(--gameday-secondary-font-color);
        }

        ${DesktopStandingsWrapper} {
            font-size: 12px;
            line-height: 12px;
            font-weight: 500;
        }

        ${DesktopStandingsWrapper}, ${NameWrapper} {
            color: var(--gameday-primary-font-color);
        }

        >div {
            margin-top: 0px;
            &:not(:first-child) {
                margin-top: 3px;
            }
        }
    }

    &.away {
        ${NameWrapper} {
            justify-content: flex-end;
        }
        ${DataWrapper} {
            margin-right: var(--gameday-section-padding-sm);
        }
    }

    &.home {
        ${DataWrapper} {
            margin-left: var(--gameday-section-padding-sm);
        }
    }
    @media (max-width: ${XS_MAX}) {
        ${DataWrapper} {
            ${NameWrapper}, ${DesktopRecordWrapper}, ${DesktopStandingsWrapper} {
                font-size: 12px;
                line-height: 12px;
            }
            ${DesktopRecordWrapper}, ${DesktopStandingsWrapper} {
                font-weight: 500;
            }
            ${NameWrapper}, ${DesktopStandingsWrapper} {
                color: var(--gameday-primary-font-color);
            }
            ${DesktopRecordWrapper} {
                color: var(--gameday-secondary-font-color);
            }
        }

        &.away {
            ${DataWrapper} {
                margin-right: 8px;
            }
        }

        &.home {
            ${DataWrapper} {
                margin-left: 8px;
            }
        }
    }
`;

export const SkeletonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid var(--gameday-divider-color);
    height: 64px;
    >${StyledBaseSkeleton} {
        height: 40px;
        margin: 0;
        &:nth-child(1) {
            width: 100px;
        }
        &:nth-child(2) {
            width: 50px;
        }
        &:nth-child(3) {
            width: 200px;
        }
        &:nth-child(4) {
            width: 50px;
        }
        &:nth-child(5) {
            width: 100px;
        }
    }
    @media (max-width: ${BREAKPOINTS.md}) {
        >${StyledBaseSkeleton} {
            &:nth-child(1) {
                width: 75px;
            }
            &:nth-child(2) {
                width: 35px;
            }
            &:nth-child(3) {
                width: 100px;
            }
            &:nth-child(4) {
                width: 35px;
            }
            &:nth-child(5) {
                width: 75px;
            }
        }
    }
    @media (max-width: ${BREAKPOINTS.sm}) {
        >${StyledBaseSkeleton} {
            &:nth-child(1) {
                width: 50px;
            }
            &:nth-child(2) {
                width: 30px;
            }
            &:nth-child(3) {
                width: 75px;
            }
            &:nth-child(4) {
                width: 30px;
            }
            &:nth-child(5) {
                width: 50px;
            }
        }
    }
`;

export const TeamSkeletonWrapper = styled.div`
    text-align: center;
    display: inline-block;
`;

export const ScoreWrapper = styled.div`
    color: var(--gameday-primary-font-color);
    width: 40px;
    font-size: ${({ scoreSize }) => scoreSize};
    line-height: ${({ scoreSize }) => scoreSize};
    font-weight: 700;

    span {
        display: inline-block;
        width: 100%;
        text-align: center;
    }
`;

export const GameStateWrapper = styled.div`
    font-weight: 700;
    font-size: 14px;
    color: var(--gameday-primary-font-color);
    text-align: center;
    text-transform: uppercase;
    @media (max-width: ${BREAKPOINTS.sm}) {
        font-size: 12px;
        padding-top: 4px;
        span {
            line-height: 12px;
        }
    }
    ${MatchupStateWrapper}{
        justify-content: center;
        
        span {
            padding: 3px 0 4px;
        }
    }
`;

export const GameStateSubtitleWrapper = styled.div`
    font-weight: 500;
    font-size: 12px;
    color: var(--gameday-secondary-font-color);
    text-align: center;
    text-transform: none;
    line-height: 12px;
    margin-top:8px;
    svg {
        margin-left: 4px;
        vertical-align: middle;
        border: 0;
        path {
            fill: var(--gameday-secondary-font-color);
        }
    }
`;

export const GameStateSubtitleDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);

`;

export const SubtitleLayoutWrapper = styled.div`
    padding: 0px 16px 8px;
`;

export const AdditionalTextWrapper = styled.div`
    color: var(--gameday-secondary-font-color);
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    text-transform: uppercase;
    text-align: center;
`;

export const TeamOverride = styled(Team)`
    >div {
        display: block;
    }
`;

export const TeamSummaryMatchUpWrapper = styled.div.attrs({
    'data-mlb-test': 'teamSummaryMatchUpWrapper'
})`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: var(--gameday-primary-font);
    padding: var(--gameday-section-padding-sm);
    box-sizing: border-box;
    ${({ $isStickyScore }) => $isStickyScore ? 'height: 76px!important' : ''}; // should we just bump the standard live height up to 76px?
`;
